import script from "./UserTypeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTypeView.vue?vue&type=script&setup=true&lang=ts"

import "./UserTypeView.vue?vue&type=style&index=0&id=cc629fa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc629fa4"]])

export default __exports__